
import { defineComponent } from "vue";
import { getAbiDurchschnitt } from "@/scripts/GradeTable";
import { SubjectName } from "@/scripts/Types";

export default defineComponent({
  name: "QualifikationGesamt",
  props: {
    gesamtpunktzahl: { type: Number, default: 0, required: true },
    ownSubjects: { required: true },
    marks: { required: true },
  },
  emits: ["imported"],
  data() {
    return {
      abiDurchschnitt: "nicht bestanden",
    };
  },
  watch: {
    gesamtpunktzahl() {
      if (this.gesamtpunktzahl != undefined) {
        this.abiDurchschnitt = getAbiDurchschnitt(this.gesamtpunktzahl);
      }
    },
  },
  methods: {
    onFileChange(e: any) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const reader = new FileReader();
      console.log(files[0]);
      if (files[0].name.slice(-5) == ".json") {
        reader.onload = (res) => {
          if (res != null && res.target != null && res.target.result != null) {
            const parsedJSON = JSON.parse(res.target.result.toString());
            this.$emit("imported", parsedJSON);
          }
        };
        reader.readAsText(files[0], "utf-8");
      }
    },
  },
  computed: {
    exportToFile() {
      const contentType = "application/json";
      const dData = JSON.stringify({
        marks: this.marks,
        ownSubjects: this.ownSubjects,
      });
      const blob = new Blob([dData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      return url;
    },
  },
});
